import React from 'react';

export interface ComparisonItem {
  label: string;
  value: string;
  sublabel?: string;
  highlighted?: boolean;
}

interface ComparisonGridProps {
  items: ComparisonItem[];
  columns?: 2 | 3 | 4;
}

export const ComparisonGrid: React.FC<ComparisonGridProps> = ({
  items,
  columns = 2,
}) => {
  const gridCols = {
    2: 'grid-cols-2',
    3: 'grid-cols-2 md:grid-cols-3',
    4: 'grid-cols-2 md:grid-cols-4',
  };

  return (
    <div className={`grid ${gridCols[columns]} gap-4`}>
      {items.map((item, index) => (
        <div
          key={index}
          className={`p-4 border ${item.highlighted ? 'bg-gray-100 border-gray-300' : 'bg-white border-gray-200'}`}
        >
          <p className="text-xs text-gray-500 mb-1">{item.label}</p>
          <p className="text-2xl font-bold text-gray-900">{item.value}</p>
          {item.sublabel && (
            <p className="text-sm text-gray-600 mt-1">{item.sublabel}</p>
          )}
        </div>
      ))}
    </div>
  );
};

// Variant for simple two-column comparison
interface TwoColumnComparisonProps {
  left: {
    title: string;
    content: React.ReactNode;
  };
  right: {
    title: string;
    content: React.ReactNode;
  };
}

export const TwoColumnComparison: React.FC<TwoColumnComparisonProps> = ({
  left,
  right,
}) => {
  return (
    <div className="grid md:grid-cols-2 gap-4">
      <div className="bg-white border border-gray-200 p-4">
        <p className="font-semibold text-gray-900 mb-2">{left.title}</p>
        <div className="text-sm text-gray-600">{left.content}</div>
      </div>
      <div className="bg-white border border-gray-200 p-4">
        <p className="font-semibold text-gray-900 mb-2">{right.title}</p>
        <div className="text-sm text-gray-600">{right.content}</div>
      </div>
    </div>
  );
};
